// eslint-disable-next-line max-len
// TODO: Need to refactor: this code the same as wgnp/static_source/components/password_operations/step_confirm_sms.js

import SmsVerificationCellphoneRecoveryForm from '../sms_verification_cellphone_recovery_form';
import FlashcallVerificationCellphoneRecoveryForm from '../flashcall_verification_cellphone_recovery_form';

import CancelOperationUrlPropMixin from '../../mixins/cancelOperationUrlProp';
import CellphoneRecoveryOperationPropMixin from '../../mixins/cellphoneRecoveryOperationProp';

import {
    CELLPHONE_RECOVERY_OPERATIONS_MUTATION_UPDATE_STATE,
} from '../../constants/cellphone_recovery_operations';

export default {
    name: 'cellphone-recovery-operations-step-confirm-sms',
    template: '#js-tmpl-cellphone-recovery-operations-step-confirm-sms',

    mixins: [CellphoneRecoveryOperationPropMixin, CancelOperationUrlPropMixin],

    components: {
        SmsVerificationCellphoneRecoveryForm,
        FlashcallVerificationCellphoneRecoveryForm,
    },
    data() {
        return {
            isTimerActive: false,
        };
    },

    computed: {
        displayCodeLength() {
            return this.responseCodeLength || 6;
        },
        notificationType() {
            return this.$store.state.cellphone_recovery.notificationType;
        },
        twofactorMethod() {
            return this.$store.state.cellphone_recovery.twofactorMethod;
        },
        userCellphone() {
            return this.$store.state.cellphone_recovery.cellphone;
        },
        isMig() {
            return this.twofactorMethod === 'mig';
        },
        isFlashCall() {
            return this.notificationType === 'flash_call';
        },
        operationUrls() {
            return this.$store.state[this.operation].urls;
        },
        migOperationUrls() {
            const urls = {
                ...this.operationUrls,
                validate: this.$store.state.cellphone_recovery.responseUrlValidate,
                status: this.$store.state.cellphone_recovery.responseUrlStatus,
                resend: this.$store.state.cellphone_recovery.responseUrlResend
            };

            return urls;
        },
        submitUrl() {
            return this.operationUrls.cellphoneRecoveryVerifySmsUrl;
        },
        linkToPersonalPage() {
            return this.$store.state.cellphone_recovery.urls.personalUrl;
        },
        dailyLimit() {
            return this.$store.state.cellphone_recovery.dailyLimit;
        },
        intervalMs() {
            return this.$store.state.cellphone_recovery.intervalMs;
        },
        requestMaxFrequency() {
            return this.$store.state.cellphone_recovery.requestMaxFrequency;
        },
        isLastAttempt() {
            return this.$store.state.cellphone_recovery.isLastAttempt;
        },
        resendAvailableAt() {
            return this.$store.state.cellphone_recovery.resendAvailableAt;
        },
        windowAvailableAt() {
            return this.$store.state.cellphone_recovery.windowAvailableAt;
        },
    },

    mounted() {
        this.initializeTimerAndUrls();
    },

    methods: {
        /* eslint-disable max-len */
        initializeTimerAndUrls() {
            const updateStateMutation = CELLPHONE_RECOVERY_OPERATIONS_MUTATION_UPDATE_STATE[this.operation];
            if (!updateStateMutation) return;

            const operationState = this.$store.state[this.operation] || {};
            const currentUrls = operationState.urls || {};
            const recoveryState = this.$store.state.cellphone_recovery || {};
            const migResendUrl = recoveryState.responseUrlResend;

            if (!currentUrls.cellphoneRecoveryResendSmsUrl && migResendUrl) {
                this.$store.commit(updateStateMutation, {
                    urls: {
                        ...currentUrls,
                        cellphoneRecoveryResendSmsUrl: migResendUrl
                    }
                });
            }

            if (recoveryState.is_last_attempt || recoveryState.isLastAttempt) {
                this.$store.commit(updateStateMutation, {
                    is_last_attempt: true,
                    isLastAttempt: true,
                    resend_available_at: recoveryState.resend_available_at || recoveryState.resendAvailableAt,
                    window_available_at: recoveryState.window_available_at || recoveryState.windowAvailableAt,
                    codeExpiresAt: recoveryState.resend_available_at || recoveryState.resendAvailableAt
                });
                return;
            }

            if (!operationState.codeExpiresAt) {
                if (recoveryState.resend_available_at) {
                    this.$store.commit(updateStateMutation, {
                        codeExpiresAt: recoveryState.resend_available_at,
                        resend_available_at: recoveryState.resend_available_at
                    });
                } else {
                    const now = Math.floor(Date.now() / 1000);
                    const timeout = operationState.codeRequestTimeout
                        || (recoveryState.twofactor_settings && recoveryState.twofactor_settings.request_timeout)
                        || 60;

                    this.$store.commit(updateStateMutation, {
                        codeExpiresAt: now + parseInt(timeout, 10)
                    });
                }
            }
        },

        onSubmitSuccess() {
            this.$emit('update', {
                operationVerified: true,
            });
            window.location.href = this.linkToPersonalPage;
        },
    },
};
